import { chunk } from 'lodash';

const DEFAULT_CHUNK_SIZE = 50;

export const processInChunks = async <T, R>(
  items: T[],
  processFn: (item: T) => Promise<R | R[]>,
  chunkSize: number = DEFAULT_CHUNK_SIZE
): Promise<R[]> => {
  const results: R[] = [];
  const chunkedItems = chunk(items, chunkSize);

  for (const chunked of chunkedItems) {
    const batchResults = await Promise.all(chunked.map(processFn));
    for (const result of batchResults) {
      if (Array.isArray(result)) {
        results.push(...result);
      } else {
        results.push(result);
      }
    }
  }

  return results;
};
